import MainDocument from 'presentations/views/components/MainDocument';
import ResourcePage from 'presentations/views/components/pages/ResourcePage';
import { get } from 'infras/rest_client';
import {
  ResourceItem,
  ResourceListItem,
} from 'presentations/api/schema/resources';
import {
  apiPath,
  resourceOgpImagePath,
  resourcePath,
  webPath,
} from 'presentations/routes/path';
import { GetStaticPropsContext } from 'next';
import { formatHeadDescription } from 'presentations/views/helpers/formatter';
import { formatToSeconds } from 'infras/datetime';
import { CustomerStoryListItem } from 'presentations/api/schema/contents';
import { getWebPage } from 'presentations/views/components/atoms/StructuredData';

interface ServerProps {
  resource: ResourceItem;
  populars: ResourceListItem[];
  description: string | null;
  category: string;
  linkCanonical: string;
  customers: CustomerStoryListItem[];
}

// 開発環境は新しい記事でテスト
// const maxPage = process.env['NODE_ENV'] === 'production' ? 5 : 1;
const maxPerPage = process.env['NODE_ENV'] === 'production' ? 100 : 20;

export async function getStaticPaths() {
  const paths: any = [];
  //   for (let page = 1; page <= maxPage; page++) {
  //     const result = await get(apiPath(`/v1/resources`), {
  //       params: { page, perPage: maxPerPage },
  //     });
  //     if (!result.isSuccess) {
  //       continue;
  //     }
  //     if (!result.data) {
  //       continue;
  //     }
  //     const resources: ResourceListItem[] = result.data;
  //     for (const resource of resources) {
  //       if (!resource.categories || resource.categories.length === 0) continue;
  //       const path = resourcePath(resource.categories[0].slug, resource.slug);
  //       paths.push(path);
  //     }
  //   }

  return {
    paths,
    fallback: 'blocking',
  };
}

export async function getStaticProps({
  params,
  locale,
  defaultLocale,
}: GetStaticPropsContext) {
  if (!params || Object.keys(params).length === 0) {
    return { props: { statusCode: 404 } };
  }
  if (locale !== defaultLocale) {
    return { props: { statusCode: 404 } };
  }

  const category = String(params.category);
  let result = await get(apiPath(`/v1/resources/${params.slug}`), {
    params: { perPage: maxPerPage },
  });

  if (!result.isSuccess) {
    return { props: { statusCode: 500 } };
  }
  if (!result.data) {
    return { props: { statusCode: 404 } };
  }
  if (!result.data.categories) {
    return { props: { statusCode: 404 } };
  }
  if (result.data.categories[0].slug !== category) {
    return { props: { statusCode: 404 } };
  }
  const resource: ResourceItem = result.data;
  if (!resource) {
    return { props: { statusCode: 404 } };
  }

  result = await get(apiPath(`/v1/resources/trend`), {
    params: { perPage: maxPerPage },
  });
  if (!result.isSuccess) {
    return { props: { statusCode: 500 } };
  }
  const populars: ResourceListItem[] = result.data || [];

  const description = formatHeadDescription(resource.body);

  result = await get(apiPath('/v1/contents/customers'), {
    params: { perPage: 3, locale },
  });
  if (!result.isSuccess) {
    return { props: { statusCode: 500 } };
  }
  const customers = result.data || [];

  const props: ServerProps = {
    resource,
    populars,
    category,
    description,
    customers,
    linkCanonical: webPath(resourcePath(category, String(params.slug))),
  };
  return { props, revalidate: 60 * 120 };
}

export default function Page(props: ServerProps) {
  // 基本はthumbnailUrlを使うが、tagsにupdateを含むなら自動生成されたOGP画像を使う
  let image = props.resource.thumbnailUrl;
  if (
    props.resource.tags.length > 0 &&
    props.resource.tags.some((tag) => tag.slug === 'update')
  ) {
    image = resourceOgpImagePath(
      props.resource.slug,
      formatToSeconds(props.resource.updatedAt),
    );
  }

  return (
    <MainDocument
      title={props.resource.title}
      description={props.description || ''}
      locales={['ja']}
      image={image}
      linkCanonical={props.linkCanonical}
      isShowDownloadLink
      isUseAdsense
      structuredData={
        <>
          <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{
              __html: getWebPage({
                url: props.linkCanonical,
                title: props.resource.title,
                createdAt: props.resource.createdAt,
                updatedAt: props.resource.updatedAt,
              }),
            }}
          />
        </>
      }
    >
      <ResourcePage
        category={props.category}
        resource={props.resource}
        populars={props.populars}
        customers={props.customers}
      />
    </MainDocument>
  );
}
